import { createEntityAdapter } from "@reduxjs/toolkit";

export const priceAdapter = createEntityAdapter({
    selectId: price => price.productId
});

export const priceSelectors = priceAdapter.getSelectors(state => state.price);

export const { selectById } = priceSelectors;
